(function () {
  if (window.__AG_PB_PD_NUTRITION_INIT__) return;
  window.__AG_PB_PD_NUTRITION_INIT__ = true;

  var openModals = [];

  function getFocusable(root) {
    if (!root) return [];
    return Array.prototype.slice.call(
      root.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return !el.hasAttribute('hidden') && el.offsetParent !== null;
    });
  }

  function lockScroll(lock) {
    if (lock) {
      document.documentElement.classList.add('ag-pb-pd-nutrition-open');
      document.body.classList.add('ag-pb-pd-nutrition-open');
    } else if (!openModals.length) {
      document.documentElement.classList.remove('ag-pb-pd-nutrition-open');
      document.body.classList.remove('ag-pb-pd-nutrition-open');
    }
  }

  function closeModal(modal) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.classList.remove('is-open');
    openModals = openModals.filter(function (m) { return m !== modal; });
    lockScroll(false);

    var opener = modal.__agPbPdNutritionOpener;
    modal.__agPbPdNutritionOpener = null;
    if (opener && typeof opener.focus === 'function') {
      try { opener.focus(); } catch (e) { /* ignore */ }
    }
  }

  function openModal(modal, opener) {
    if (!modal) return;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    modal.hidden = false;
    modal.classList.add('is-open');
    modal.__agPbPdNutritionOpener = opener || null;
    if (openModals.indexOf(modal) === -1) openModals.push(modal);
    lockScroll(true);

    var closeBtn = modal.querySelector('[data-ag-pb-pd-nutrition-close]');
    var focusTarget = closeBtn || getFocusable(modal)[0] || modal;
    window.requestAnimationFrame(function () {
      try { focusTarget.focus(); } catch (e) { /* ignore */ }
    });
  }

  function bindModal(modal) {
    if (!modal || modal.dataset.agPbPdNutritionBound === 'true') return;
    modal.dataset.agPbPdNutritionBound = 'true';

    modal.addEventListener('click', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.closest('[data-ag-pb-pd-nutrition-close]')) {
        e.preventDefault();
        closeModal(modal);
      }
    });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeModal(modal);
        return;
      }
      if (e.key !== 'Tab') return;
      var focusable = getFocusable(modal);
      if (!focusable.length) {
        e.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function bindOpen(btn) {
    if (!btn || btn.dataset.agPbPdNutritionOpenBound === 'true') return;
    btn.dataset.agPbPdNutritionOpenBound = 'true';

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = btn.getAttribute('aria-controls');
      var modal = id ? document.getElementById(id) : null;
      if (!modal) {
        modal = btn.closest('.ag-pb-pd__gallery-col')
          ? btn.closest('.ag-pb-pd__gallery-col').querySelector('[data-ag-pb-pd-nutrition-modal]')
          : null;
      }
      if (!modal) return;
      bindModal(modal);
      openModal(modal, btn);
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll('[data-ag-pb-pd-nutrition-open]');
    Array.prototype.forEach.call(buttons, bindOpen);
    var modals = scope.querySelectorAll('[data-ag-pb-pd-nutrition-modal]');
    Array.prototype.forEach.call(modals, bindModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e && e.target ? e.target : document);
  });
})();
